import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    DeletePopHover,
    Typography,
    Form,
    message,
    Modal,
    Input,
    setParamsFilter,
    Card,
    Select,
    Switch,
    Textarea,
    Radio,
    Tabs,
    InputNumber,

} from "../../../ui/ot";
import { useCRUDController } from "../../../ui/classify_structure/CRUDController"
import { useTranslation } from "react-i18next";
const LibraryTransferLimitManagement = ({
    permission_level = null, 
}) => {
    return (
        <Row>
            <Col span={24}>
                <LibraryTransferLimitManagementTable keyPrefix={'library.backstage.library_transfer_limit_management'} permission_level={permission_level} />
            </Col>
        </Row>
    )
}
const LibraryTransferLimitManagementTable = ({
    keyPrefix = 'library.backstage.library_transfer_limit_management',
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef(null);
    const columns = [
        {
            title: t('special_collection_classification'),
            dataIndex: "description",
            key: "description",
        },
        {
            title: t('transfer_out_library'),
            dataIndex: "description",
            key: "description",
        },
        {
            title: t('transfer_in_library'),
            dataIndex: "unit",
            key: "unit",
        },
        {
            title: t('is_transferable'),
            dataIndex: "issuesperunit",
            key: "issuesperunit",
        },

    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [axiosMode, setAxiosMode] = useState("get");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.frequencyid);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.frequencyid);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.frequencyid);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.frequencyid
                );
                selectRow = selectRow.filter(
                    (row) => row.frequencyid !== record.frequencyid
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);
        // form.resetFields();
        // let editRecord = { ...record }
        // if (editRecord) {
        //     Object.keys(editRecord).forEach((key) => {
        //         if (key !== "key") {
        //             form.setValue(key, editRecord[key]);
        //         }
        //     });
        // }
    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    frequencyid: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    frequencyid: val?.frequencyid,
                };
            });
        }
        if (data.length > 0) {
            deleteData(data);
        } else {
            message.info(t('please_select_item'));
        }
    };
    const onFormFinish = (value) => {
        console.log(value);
        if (axiosMode === "post") {
            postData([value]);
        } else if (axiosMode === "patch") {
            patchData([value]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    };
    const {

        getData,
        postData,
        patchData,
        deleteData,
        ResponseData,
    } = useCRUDController({
        apiRoute: "",
        onFinish,
        onBefore,
    });
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        checkAll();
    }, []);
    return (
        <Row gutter={[8, 8]}>


            <Col span={24}>
                <ProTableOt
                    rowKey={"id"}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return getData({
                            ...newParams,
                        });
                    }}
                    toolBarRender={() => {
                        return permission_level === 1 ? [
                            <Button
                                onClick={() => {
                                    Modal.confirm({
                                        title: "轉移設定",
                                        handleOk: () => {
                                        },
                                        handleCancel: () => {
                                        },
                                        okText: "確定",
                                        cancelText: "取消",
                                        content: <>
                                            將勾選項目變更為可轉移
                                        </>
                                    })
                                }}>
                                可轉移
                            </Button>,
                            <Button
                                onClick={() => {
                                    Modal.confirm({
                                        title: "轉移設定",
                                        handleOk: () => {
                                        },
                                        handleCancel: () => {
                                        },
                                        okText: "確定",
                                        cancelText: "取消",
                                        content: <>
                                            將勾選項目變更為不可轉移
                                        </>
                                    })
                                }}>
                                不可轉移
                            </Button>,
                        ] : [];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys,
                        setSelectedRowsInfo,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}

                />
            </Col>
        </Row>
    );
};

const LibraryTransferLimitManagementForm = (
    {
        keyPrefix = 'library.backstage.library_transfer_limit_management',
        propsForm,
        field,
        initialValues,
        defaultValue,
        onFormFinish = () => { },
        propsOnValuesChange = () => { }

    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [preview_code_form] = Form.useForm();
    const { t } = useTranslation('translation', { keyPrefix })
    const [activeKey, setActiveKey] = useState("serial_code_setting")
    const actionRef = useRef(null);
    const columns = [
        {
            title: t('number'),
            dataIndex: "number",
            key: "number",
        },
        {
            title: t('publication_date'),
            dataIndex: "publication_date",
            key: "publication_date",
        },

    ];
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        values.collection_code = values.collection_code === "0" ? null : values.collection_code
        values.shelving_control_number = values.shelving_control_number ?? null
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        console.log({ value })
        propsOnValuesChange(value)
    };

    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
        form.setFieldsValue({ ...formValues, ...defaultValue })
    }, [defaultValue])

    return (
        <Row>
            <Col span={24}>
                <Tabs
                    onChange={setActiveKey}
                    activeKey={activeKey}
                    items={[
                        {
                            tab: t('serial_code_setting'),
                            key: 'serial_code_setting'
                        },
                        {
                            tab: t('preview_code_settings_display'),
                            key: 'preview_code_settings_display'
                        }
                    ]} />
            </Col>
            <Col span={24}
                hidden={activeKey !== "serial_code_setting"}
            >
                <Form
                    form={preview_code_form}
                    onValuesChange={(value, { name, type }) => {
                        console.log({
                            value
                        })
                    }}
                    onFinish={(value) => {

                    }}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
            <Col
                span={24}
                hidden={activeKey !== "preview_code_settings_display"}
            >
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                        <Row>
                            <Col>
                                <Button>
                                    產生預覽
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={14} lg={14} md={14} sm={24} xs={24}>
                        <Form
                            form={form}
                            onValuesChange={onValuesChange}
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <Row>
                                <Col span={24}>
                                    <PreviewCodeFormItemComponent
                                        keyPrefix={keyPrefix}
                                        field={field}
                                        initialValues={initialValues}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col xxl={10} lg={10} md={10} sm={24} xs={24}>
                        <ProTableOt
                            rowKey={"id"}
                            actionRef={actionRef}
                            columns={columns}
                            // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                            request={async (params = {}, sort, filter) => {
                                // let newParams = {};
                                // let order = setOrders(sort);
                                // newParams = {
                                //     ...params,
                                //     ...newParams,
                                //     order,
                                //     size: params.pageSize,
                                //     cur_page: params.current,
                                //     custom_filter_value: params.keyword ?? "",
                                //     custom_filter_key: custom_filter_key,
                                // };
                                // newParams = setParamsFilter({
                                //     ...newParams,
                                // });

                                return {
                                    data: [],
                                    total: 0
                                }
                            }}
                            toolBarRender={() => {
                                return [];
                            }}
                            rowSelection={{
                                type: "",
                            }}
                        />
                    </Col>
                </Row>

            </Col>
        </Row>
    );

}
const FormItemComponent = ({ keyPrefix, field, initialValues = {}, options }) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'id']}
                            fieldKey={[field?.fieldKey ?? '', 'id'].join('.')}
                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            <Col xxl={24} lg={24} md={24} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`name`)}
                            name={[field?.name ?? '', 'name']}
                            fieldKey={[field?.fieldKey ?? '', 'unit'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`description`)}
                            name={[field?.name ?? '', 'description']}
                            fieldKey={[field?.fieldKey ?? '', 'description'].join('.')}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`numbering_formula`)}
                            name={[field?.name ?? '', 'numberingmethod']}
                            fieldKey={[field?.fieldKey ?? '', 'numberingmethod'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`display_order`)}
                            name={[field?.name ?? '', 'displayorder']}
                            fieldKey={[field?.fieldKey ?? '', 'displayorder'].join('.')}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[4, 4]}>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                <Card
                                    styles={{
                                        padding: 8
                                    }}
                                    title={"X"}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`label`)}
                                                name={[field?.name ?? '', 'label1']}
                                                fieldKey={[field?.fieldKey ?? '', 'label1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`add`)}
                                                name={[field?.name ?? '', 'add1']}
                                                fieldKey={[field?.fieldKey ?? '', 'add1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`every`)}
                                                name={[field?.name ?? '', 'every1']}
                                                fieldKey={[field?.fieldKey ?? '', 'every1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`set_back_to`)}
                                                name={[field?.name ?? '', 'setto1']}
                                                fieldKey={[field?.fieldKey ?? '', 'setto1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`when_more_than`)}
                                                name={[field?.name ?? '', 'whenmorethan1']}
                                                fieldKey={[field?.fieldKey ?? '', 'whenmorethan1'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`formatting`)}
                                                name={[field?.name ?? '', 'numbering1']}
                                                fieldKey={[field?.fieldKey ?? '', 'numbering1'].join('.')}
                                            >
                                                <Select
                                                    allowClear={true}
                                                    placeholder=""
                                                    options={[]}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                            {/* Title Y with suffix 2 */}
                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                <Card
                                    styles={{
                                        padding: 8
                                    }}
                                    title={"Y"}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`label`)}
                                                name={[field?.name ?? '', 'label2']}
                                                fieldKey={[field?.fieldKey ?? '', 'label2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`add`)}
                                                name={[field?.name ?? '', 'add2']}
                                                fieldKey={[field?.fieldKey ?? '', 'add2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`every`)}
                                                name={[field?.name ?? '', 'every2']}
                                                fieldKey={[field?.fieldKey ?? '', 'every2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`set_back_to`)}
                                                name={[field?.name ?? '', 'setto2']}
                                                fieldKey={[field?.fieldKey ?? '', 'setto2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`when_more_than`)}
                                                name={[field?.name ?? '', 'whenmorethan2']}
                                                fieldKey={[field?.fieldKey ?? '', 'whenmorethan2'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`formatting`)}
                                                name={[field?.name ?? '', 'numbering2']}
                                                fieldKey={[field?.fieldKey ?? '', 'numbering2'].join('.')}
                                            >
                                                <Select
                                                    allowClear={true}
                                                    placeholder=""
                                                    options={[]}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                            {/* Title Z with suffix 3 */}
                            <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                <Card
                                    styles={{
                                        padding: 8
                                    }}
                                    title={"Z"}
                                >
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`label`)}
                                                name={[field?.name ?? '', 'label3']}
                                                fieldKey={[field?.fieldKey ?? '', 'label3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`add`)}
                                                name={[field?.name ?? '', 'add3']}
                                                fieldKey={[field?.fieldKey ?? '', 'add3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`every`)}
                                                name={[field?.name ?? '', 'every3']}
                                                fieldKey={[field?.fieldKey ?? '', 'every3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`set_back_to`)}
                                                name={[field?.name ?? '', 'setto3']}
                                                fieldKey={[field?.fieldKey ?? '', 'setto3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`when_more_than`)}
                                                name={[field?.name ?? '', 'whenmorethan3']}
                                                fieldKey={[field?.fieldKey ?? '', 'whenmorethan3'].join('.')}
                                            >
                                                <InputNumber />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...field}
                                                labelCol={12}
                                                wrapperCol={12}
                                                label={t(`formatting`)}
                                                name={[field?.name ?? '', 'numbering3']}
                                                fieldKey={[field?.fieldKey ?? '', 'numbering3'].join('.')}
                                            >
                                                <Select
                                                    allowClear={true}
                                                    placeholder=""
                                                    options={[]}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

        </Row>
    );
};
const PreviewCodeFormItemComponent = ({ keyPrefix, field, initialValues = {}, options }) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[16, 16]}>
            {/* <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'id']}
                            fieldKey={[field?.fieldKey ?? '', 'id'].join('.')}
                        >
                            <div></div>
                        </Form.Item>
                    </Col>
                </Row>
            </Col> */}
            <Col xxl={24} lg={24} md={24} sm={24} xs={24}>
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    {...field}
                                    labelCol={12}
                                    wrapperCol={12}
                                    label={t(`frequency`)}
                                    name={[field?.name ?? '', 'name']}
                                    fieldKey={[field?.fieldKey ?? '', 'unit'].join('.')}
                                    rules={[{ required: true, message: t('please_enter') }]}

                                >
                                    <Select options={[]} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    {...field}
                                    labelCol={12}
                                    wrapperCol={12}
                                    label={t(`first_issue_publication_date`)}
                                    name={[field?.name ?? '', 'description']}
                                    fieldKey={[field?.fieldKey ?? '', 'description'].join('.')}
                                    rules={[{ required: true, message: t('please_enter') }]}

                                >
                                    <Input type={"date"} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    {...field}
                                    labelCol={12}
                                    wrapperCol={12}
                                    label={t(`subscription_length`)}
                                    name={[field?.name ?? '', 'numberingmethod']}
                                    fieldKey={[field?.fieldKey ?? '', 'numberingmethod'].join('.')}
                                    rules={[{ required: true, message: t('please_enter') }]}
                                >
                                    <InputNumber />
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <Row gutter={[4, 4]}>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                        <Card
                                            styles={{
                                                padding: 2
                                            }}
                                            title={"X"}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={12}
                                                        wrapperCol={12}
                                                        label={t(`begins_with`)}
                                                        name={[field?.name ?? '', 'lastvalue1']}
                                                        fieldKey={[field?.fieldKey ?? '', 'lastvalue1'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={12}
                                                        wrapperCol={12}
                                                        label={t(`inner_counter`)}
                                                        name={[field?.name ?? '', 'innerloop1']}
                                                        fieldKey={[field?.fieldKey ?? '', 'innerloop1'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    {/* Title Y with suffix 2 */}
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                        <Card
                                            styles={{
                                                padding: 2
                                            }}
                                            title={"Y"}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={12}
                                                        wrapperCol={12}
                                                        label={t(`begins_with`)}
                                                        name={[field?.name ?? '', 'lastvalue1']}
                                                        fieldKey={[field?.fieldKey ?? '', 'lastvalue1'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={12}
                                                        wrapperCol={12}
                                                        label={t(`inner_counter`)}
                                                        name={[field?.name ?? '', 'innerloop2']}
                                                        fieldKey={[field?.fieldKey ?? '', 'innerloop2'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    {/* Title Z with suffix 3 */}
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                        <Card
                                            styles={{
                                                padding: 2
                                            }}
                                            title={"Z"}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={12}
                                                        wrapperCol={12}
                                                        label={t(`begins_with`)}
                                                        name={[field?.name ?? '', 'lastvalue3']}
                                                        fieldKey={[field?.fieldKey ?? '', 'lastvalue3'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        {...field}
                                                        labelCol={12}
                                                        wrapperCol={12}
                                                        label={t(`inner_counter`)}
                                                        name={[field?.name ?? '', 'innerloop3']}
                                                        fieldKey={[field?.fieldKey ?? '', 'innerloop3'].join('.')}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Col>

        </Row>
    );
};
export default LibraryTransferLimitManagement
export { LibraryTransferLimitManagementTable, LibraryTransferLimitManagementForm }
